/**
 * Regular expressions shared by the form schema, the payload schema and the
 * mock backend. Mirrors the contract (workwise-contract.md sections 1-3); the
 * backend remains the authority.
 *
 * Node-safe: relative imports only, no import.meta.
 */

/** VM names (contract section 2). */
export const APP_VM_REGEX = /^[pd]ww\d{3}app\d{2}$/
export const DB_VM_REGEX = /^[pd]ww\d{3}db\d{2}$/
export const GATEWAY_VM_REGEX = /^[pd]mtwwt0[1-9]$/

/** Three digits; 000 is rejected separately. */
export const CUSTOMER_NUMBER_REGEX = /^\d{3}$/

/** Azure location code, e.g. "eastus2". */
export const REGION_CODE_REGEX = /^[a-z][a-z0-9]{2,29}$/

/** kv://<vault>/<secret>. */
export const KV_REF_REGEX = /^kv:\/\/[a-z][a-z0-9-]{1,22}[a-z0-9]\/[A-Za-z0-9-]{1,127}$/

export const SLUG_REGEX = /^[a-z0-9]+(-[a-z0-9]+)*$/

/** The SQL login of "SQL Server authentication": a letter first, then letters, digits or underscores (3 to 32). */
export const SQL_LOGIN_REGEX = /^[A-Za-z][A-Za-z0-9_]{2,31}$/

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const UUID_V4_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
